<template>
  <avs-button
    v-bind="{ ...$attrs }"
    v-on="{ ...$listeners }"
    color="success"
    iconI="mdi-content-save"
    noSpantext
  >
    <template v-slot:name>{{ $t("commons.save") }}</template>
  </avs-button>
</template>

<script>
export default {
  name: "SaveButton",
  props: {},
  methods: {}
}
</script>
